import React from 'react';
import { useMessages } from './useMessages';
import { Messages } from './Messages';
export const MessagesForEntity = ({ entityKind, entityId, pollInterval, ...messagesComponentProps }) => {
    const { messages, sendMessage, isPending, sendIsPending, isSyncing, error, sendError, } = useMessages(entityKind, entityId, pollInterval);
    return (React.createElement(Messages, { messages: messages, sendMessage: sendMessage, isPending: isPending, sendIsPending: sendIsPending, isSyncing: isSyncing, fetchError: error, sendError: sendError, ...messagesComponentProps }));
};
